import styles from "./SelectTeamDialog.module.css";
import { Dialog } from "gui/dialog/dialog";
import { IconButton } from "components/Button/IconButton";
import { AnchorButtonTextOnly } from "components/ButtonTextOnly/AnchorButtonTextOnly";
import { Identity } from "components/Identity";

import { IconLoading } from "components/Icons/IconLoading";
import { IconCross } from "components/Icons/IconCross";
import { IconArrowRight } from "components/Icons/IconArrowRight";

import { useSession } from "gui/session/session";
import { useMyTeamsIfLoggedIn } from "shared/teams/useMyTeams";

interface Plan {
  id: number;
  name: string;
}

type GetSubscribeUrl = (
  team: { handle: string },
  plan: { name: string }
) => string;

type GetNewTeamUrl = (plan: { name: string }) => string;

interface Props {
  isOpen: boolean;
  close: () => void;
  plan: Plan;
  getSubscribeUrl: GetSubscribeUrl;
  getNewTeamUrl: GetNewTeamUrl;
}

export function SelectTeamDialog(props: Props) {
  return (
    <Dialog
      label="Select team"
      size="md"
      isOpen={props.isOpen}
      onDismiss={props.close}
    >
      <Content {...props} />
    </Dialog>
  );
}

function Content(props: Props) {
  const teams = useMyTeamsIfLoggedIn(useSession());

  if (!teams) {
    // Teams should already be loaded by the context switcher
    return (
      <div className={styles.center}>
        <IconLoading />
      </div>
    );
  }

  return (
    <div className={styles.dialog}>
      <h2>
        Select an existing team to upgrade
        <IconButton theme="ghost" size="S" onClick={props.close}>
          <IconCross />
        </IconButton>
      </h2>
      <ul>
        {teams
          // Must be admin to change team plan
          .filter((team) => team.membership.role === "admin")
          // Can't upgrade enterprise teams
          .filter((team) => team.service_tier.is_public)
          .map((team) => (
            <li key={team.id}>
              <Identity
                size="L"
                color="text-primary"
                owner={{
                  type: "team",
                  handle: team.handle,
                  profile_image_url: team.profile_image_url ?? undefined,
                }}
              />

              <AnchorButtonTextOnly
                size="M"
                theme="secondary"
                href={props.getSubscribeUrl(team, props.plan)}
              >
                Upgrade team
                <IconArrowRight />
              </AnchorButtonTextOnly>
            </li>
          ))}

        <li>
          <span />

          <AnchorButtonTextOnly
            size="M"
            theme="primary"
            href={props.getNewTeamUrl(props.plan)}
          >
            Create team
            <IconArrowRight />
          </AnchorButtonTextOnly>
        </li>
      </ul>
    </div>
  );
}
